import React, { useEffect, useRef, useState } from "react";
import MainSections from "./MainSections";
import { SidebarContainer } from "../../components";
import { Button } from "@/shared";
import { useAuth } from "@/hooks";

const Help = () => {
  const headerRef = useRef();
  const [headerContext, setHeaderContext] = useState();
  const { user } = useAuth();

  const canReopenTutorial =
    Boolean(user?.accountHolder) ||
    ["owner", "admin", "superAdmin"].includes(user?.authority);

  const openTutorial = () => {
    if (typeof window === "undefined") return;
    window.dispatchEvent(
      new CustomEvent("attune:tutorial-open", {
        detail: { type: "full" },
      })
    );
  };

  const openChecklist = () => {
    if (typeof window === "undefined") return;
    window.dispatchEvent(
      new CustomEvent("attune:tutorial-open", {
        detail: { type: "checklist" },
      })
    );
  };

  useEffect(() => {
    setHeaderContext(headerRef.current);
  }, [headerRef.current]);

  const renderTabHeader = (headerProps) => {
    return <div ref={headerRef}></div>;
  };

  return (
    <SidebarContainer hideSidebar header={renderTabHeader}>
      {({ parentHeight, parentWidth }) => {
        const offsetTop = headerContext?.offsetTop || 0;
        const offsetHeight = headerContext?.offsetHeight || 0;

        return (
          <div className="h-full overflow-y-auto w-full">
            <div className="w-full px-4 sm:px-6 lg:px-8 py-12">
              <div className="text-center mb-12">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                  Help Center
                </h1>
                <p className="text-xl text-gray-600">
                  Find answers to your questions and get support
                </p>
                {canReopenTutorial && (
                  <div className="mt-4 flex items-center justify-center gap-2">
                    <Button type="alternative" size="sm" onClick={openTutorial}>
                      Reopen UI tour
                    </Button>
                    <Button type="alternative" size="sm" onClick={openChecklist}>
                      Open checklist only
                    </Button>
                  </div>
                )}
              </div>

              <MainSections />
            </div>
          </div>
        );
      }}
    </SidebarContainer>
  );
};

export default Help;
